import React, {Component} from 'react';
import {Provider} from 'react-redux';

export default (store) => {
  return (WrappedComponent) => {
    return class WithStore extends Component{
      render(){

        //console.log(WrappedComponent, this.props);
        return (
          <Provider store={store}>
            <WrappedComponent {...this.props}/>
          </Provider>
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./common/hocs/withStore.js